import { IconButton, Page, Sidebar } from "@eisox/design-system";
import { PanelLeftIcon } from "@eisox/icons";
import { useMediaQuery } from "@eisox/tools";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { buildingApi, meterApi } from "~/api";
import { consumptionSearchSchema } from "~/features/consumption";
import { requirePagePermission } from "~/helpers/auth/route-permission.helper";
import { buildingPageHead } from "~/helpers/document-title.helper";
import { m } from "~/paraglide/messages";

export const Route = createFileRoute("/_authenticated/buildings_/$buildingId/consumption")({
  validateSearch: consumptionSearchSchema,
  beforeLoad: ({ context: { permissions }, params: { buildingId }, preload }) => {
    requirePagePermission(permissions, "consumption", buildingId, preload);
  },
  loader: async ({ context: { queryClient }, params: { buildingId } }) => {
    await Promise.all([
      queryClient.ensureQueryData(meterApi.queries.building(buildingId)),
      queryClient.ensureQueryData(buildingApi.queries.weatherStations(buildingId)),
    ]);
  },
  head: ({ match: { context }, params: { buildingId } }) =>
    buildingPageHead(context.queryClient, buildingId, m.consumption()),
  component: ConsumptionLayout,
});

function ConsumptionLayout() {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Page.Root>
      {isMobile && (
        <Page.Header>
          <Sidebar.Trigger asChild>
            <IconButton>
              <PanelLeftIcon />
            </IconButton>
          </Sidebar.Trigger>
          <Page.Title>{m.consumption()}</Page.Title>
        </Page.Header>
      )}
      <Page.Content
        className="mt-2.5 gap-2.5 p-2.5 md:mt-10 md:gap-5 md:p-5 min-h-0 flex flex-1 flex-col overflow-y-auto"
        data-testid="Consumption"
      >
        <Outlet />
      </Page.Content>
    </Page.Root>
  );
}
